import { CapoPlugin } from "/builds/webcontact/lossburg/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];